module.exports = __webpack_public_path__ + "media/images/loghi/icon_media_scoreboard-5e6fb21ff27dd0c3a5d123932376a26e.svg";